import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header.js";
import Footer from "../Footer.js";
import SubscribeButton from "../SubscribeButton.js";
import ReviewStrip from "../ReviewStrip.js";

/** Pages that show the reviews carousel (including when logged in). */
const REVIEW_STRIP_PATHS = ["/", "/about", "/faq", "/pricing", "/guide", "/mental-clarity", "/mental-noise", "/structured-thinking", "/emotional-awareness", "/better-decisions"];

const AppShell = ({
  children,
  headerProps,
  showFooter = true,
  showReviewStrip = true
}) => {
  const { pathname } = useLocation();
  const onReviewStripPage =
    REVIEW_STRIP_PATHS.includes(pathname) ||
    pathname.startsWith("/guide/common-questions") ||
    pathname.startsWith("/mental-clarity/") ||
    pathname.startsWith("/mental-noise/") ||
    pathname.startsWith("/structured-thinking/") ||
    pathname.startsWith("/emotional-awareness/") ||
    pathname.startsWith("/better-decisions/");
  const shouldShowReviewStrip = showReviewStrip && onReviewStripPage;

  return (
    <div className="App">
      <Header {...headerProps} />
      {children}
      <SubscribeButton isSubscriber={headerProps?.isSubscriber} verifiedEmail={headerProps?.verifiedEmail} />
      {shouldShowReviewStrip ? (
        <>
          <section className="sessions-yours" aria-labelledby="sessions-yours-heading">
            <h2 id="sessions-yours-heading" className="sessions-yours__heading">
              Your sessions stay yours
            </h2>
            <p className="sessions-yours__body">
              Your data is not sold and is never used to train any AI. You can export or delete everything at any
              moment — this is a private space.
            </p>
          </section>
          <ReviewStrip />
        </>
      ) : null}
      {showFooter ? <Footer isPaidSubscriber={headerProps?.isPaidSubscriber} verifiedEmail={headerProps?.verifiedEmail} /> : null}
    </div>
  );
};

export default AppShell;
